module.exports = __webpack_public_path__ + "static/media/gift.0672e30f.svg";